export class MyRoom {
    room_id: number;
    room_name: string;
    start_time: any;
    isJackpot: boolean;
    bingo_type: number;
    my_tickets: MyTicket[];
    formatted_start_time: any;
    isFriendsRoom: boolean;
    image: string;
    isFabGrabRoom: boolean;
    features: string[];
    displayHeaderForSessionRoom?: boolean;
}

export class MyTicket {
    transaction_date: string;
    currency: string;
    config_name: string;
    features: string[];
    room_id: number;
    jackpot: Jackpot[];
    prebuy_type: string;
    bingo_type: number;
    buyin_type: string[];
    ticket_cost: Amount;
    minimum_tickets: number;
    prebuy_enable: boolean;
    status: string;
    round_id: number;
    parent_room_id: number;
    transaction_id: number;
    amount_debited: any;
    display_name: string;
    winning_amount: Amount;
    free_ratio: any;
    room_name: string;
    purchased_count: number;
    game_config_id: number;
    start_time: any;
    maximum_tickets: number;
    istxtRedCls: boolean;
}

export class Jackpot {
    pjp_id: number;
    pjp_name: string;
    amount: Amount[];
}

export class Amount {
    Bonus: number;
    Cash: number;
}
